import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Account() {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/change-password", f); toast.success("Mot de passe modifié"); setF({ current_password: "", new_password: "" }); } catch (ex) { toast.error(errMsg(ex)); }
  };
  return (
    <div className="space-y-8 max-w-md">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Mon compte</h1>
        <p className="text-slate-500 mt-1">{user.email}</p>
      </div>
      <form onSubmit={submit} data-testid="change-password-form" className="rounded-2xl border border-emerald-900/10 bg-white p-6 space-y-4">
        <div className="space-y-1.5"><Label>Mot de passe actuel</Label><Input required type="password" data-testid="current-password-input" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} /></div>
        <div className="space-y-1.5"><Label>Nouveau mot de passe (min. 8)</Label><Input required minLength={8} type="password" data-testid="new-password-input" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} /></div>
        <Button type="submit" className="rounded-full" data-testid="change-password-submit">Modifier le mot de passe</Button>
      </form>
    </div>
  );
}
